import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import ContentRoutes from 'ContentUtils/Routes';
import { Button } from 'foundations-components/transitional/components/Button';
import { DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Flex } from 'foundations-components/components/Flex';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getContentModelId, getContentModelName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-ignore not typed
import { getMABExperimentVariantsWithMaster } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getHasMABAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { TestIcon } from 'foundations-assets/icons/components/TestIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MABControls = ({
  autoSave,
  onManageTestClick,
  TestVariationTourSecondStep,
  endTour,
  goToStepTwo
}) => {
  const categoryId = useSelector(getCategoryId);
  const currentId = useSelector(getContentModelId);
  const currentName = useSelector(getContentModelName);
  const variants = useSelector(getMABExperimentVariantsWithMaster);
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const hasMABAccess = useSelector(getHasMABAccess);
  const handleVariantClick = variantId => {
    if (hasUnsavedChanges) {
      autoSave().then(() => {
        window.location.href = ContentRoutes.edit(variantId, categoryId);
      }).catch(error => {
        console.error(error);
      });
    } else {
      // eslint-disable-next-line react-hooks/immutability
      window.location.href = ContentRoutes.edit(variantId, categoryId);
    }
  };
  const dropdown = /*#__PURE__*/_jsx(Dropdown, {
    buttonStyles: {
      padding: '200',
      marginInlineStart: '100'
    },
    buttonText: /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: TestIcon,
        paddingBlock: "0",
        paddingInlineStart: "0",
        paddingInlineEnd: "100"
      }), /*#__PURE__*/_jsx(TruncateString, {
        maxWidth: 250,
        children: currentName
      })]
    }),
    buttonUse: "tertiary-light",
    onOpenComplete: goToStepTwo,
    onOpenChange: ({
      target: {
        value: open
      }
    }) => {
      if (!open) {
        endTour();
      }
    },
    children: /*#__PURE__*/_jsx(TestVariationTourSecondStep, {
      children: /*#__PURE__*/_jsxs(List, {
        wrapChildren: true,
        children: [variants.map(variant => {
          const variantId = variant.get('id');
          const name = currentId === variantId ? currentName : variant.get('name');
          return /*#__PURE__*/_jsx(Button, {
            active: currentId === variantId,
            onClick: () => handleVariantClick(variantId.toString()),
            children: name
          }, variantId);
        }), hasMABAccess && /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(DropdownDivider, {}), /*#__PURE__*/_jsx(Button, {
            use: "transparent",
            onClick: onManageTestClick,
            paddingInline: "500",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pageSettings.mabControls.manageTest"
            })
          })]
        }, "manageTest")]
      })
    })
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "abDropdownControls.tooltip"
    }),
    placement: "bottom",
    children: dropdown
  });
};
export default MABControls;